export function getRandomNumber(numberLength: number = 6): number {
  if (numberLength > 16) throw new Error('Random number length can not be more than 16');
  let rawNumber = Math.random();
  for (let i = 1; i <= numberLength; i++) {
    rawNumber = rawNumber * 10;
  }

  return Math.trunc(rawNumber);
}
